module.exports = __webpack_public_path__ + "static/media/logo.a2df9ceb.svg";